/**
 * VENDENS - Campaign & Modal JS
 */
function initModalsv2() {
    const modal = document.getElementById('details-modal');
    if (modal && modal.parentElement !== document.body) {
        // Stacking context sorununu çözmek için modal'ı body'nin en sonuna taşıyoruz
        document.body.appendChild(modal);
    }
}

function initCampaignTimer() {
    initModalsv2();

    const timerElement = document.getElementById('campaign-timer-v2');

    if (window.vendensCampaignTimerIntervalV2) {
        clearInterval(window.vendensCampaignTimerIntervalV2);
        window.vendensCampaignTimerIntervalV2 = null;
    }

    if (!timerElement) return;

    const endDateStr = timerElement.getAttribute('data-end-date');
    if (!endDateStr) {
        timerElement.textContent = 'Kampanya tarihi bulunamadı';
        return;
    }

    const targetDate = new Date(endDateStr).getTime();
    if (Number.isNaN(targetDate)) {
        timerElement.textContent = 'Tarih formatı hatalı';
        return;
    }

    const updateTimer = () => {
        const now = Date.now();
        const distance = targetDate - now;

        if (distance <= 0) {
            const countdownWrap = timerElement.closest('.campaign-countdown-v2');
            if (countdownWrap) countdownWrap.style.display = 'none';
            clearInterval(window.vendensCampaignTimerIntervalV2);
            window.vendensCampaignTimerIntervalV2 = null;
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const h = hours.toString().padStart(2, '0');
        const m = minutes.toString().padStart(2, '0');
        const s = seconds.toString().padStart(2, '0');

        if (days > 0) {
            timerElement.innerHTML = `İndirimin bitmesine <strong>${days} gün ${h}:${m}:${s}</strong> kaldı!`;
        } else if (hours > 0) {
            timerElement.innerHTML = `İndirimin bitmesine <strong>${h}:${m}:${s}</strong> kaldı!`;
        } else {
            timerElement.innerHTML = `İndirimin bitmesine <strong>${m}:${s}</strong> kaldı!`;
        }
    };

    updateTimer();
    window.vendensCampaignTimerIntervalV2 = setInterval(updateTimer, 1000);
}

document.addEventListener('DOMContentLoaded', initCampaignTimer);
// Re-init if Shopify Customizer reloads section
document.addEventListener('shopify:section:load', initCampaignTimer);

if (!window.vendensCampaignVariantBindV2) {
    window.vendensCampaignVariantBindV2 = true;

    document.addEventListener('change', function(event) {
        if (event.target.closest('variant-selects') || event.target.closest('variant-radios') || event.target.closest('form[action*="/cart/add"]')) {
            setTimeout(initCampaignTimer, 500);
        }
    });
}

/**
 * Copy Coupon Code to Clipboard
 */
function copyCouponCode(button) {
    const code = button.dataset.code;
    const originalText = button.innerText;

    if (!code) return;

    navigator.clipboard.writeText(code).then(() => {
        button.innerText = 'KOPYALANDI';
        button.classList.add('copied');

        setTimeout(() => {
            button.innerText = originalText;
            button.classList.remove('copied');
        }, 2000);
    }).catch(err => {
        console.error('Kopyalama hatası:', err);
        // Fallback
        const textArea = document.createElement("textarea");
        textArea.value = code;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            button.innerText = 'KOPYALANDI';
            button.classList.add('copied');
            setTimeout(() => {
                button.innerText = originalText;
                button.classList.remove('copied');
            }, 2000);
        } catch (err) {
            alert('Kod: ' + code);
        }
        document.body.removeChild(textArea);
    });
}

/**
 * Product Details Modal (More Info)
 */
function openDetailsModal() {
    const modal = document.getElementById('details-modal');
    if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
}

function closeDetailsModal() {
    const modal = document.getElementById('details-modal');
    if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
    }
}

// Global click to close modals
window.addEventListener('click', function (event) {
    const detailsModal = document.getElementById('details-modal');
    if (event.target == detailsModal) {
        closeDetailsModal();
    }
});
